<template>
    <div
        v-if="isAvailable"
        id="asd"
        :style="tooltipStyle"
        class="tooltip-vue"
        :class="customClass"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
    >
        <span v-html="localText" />
        <div class="arrow arrow--top-right"></div>
    </div>
</template>

<script>
export default {
    scopeName: 'tooltip',
    props: {
        text: {
            type: String,
            required: false,
            default: ''
        },
        textColor: {
            type: String,
            default: '#000000'
        },
        backgroundColor: {
            type: String,
            default: '#ffffff'
        },
        timeout: {
            type: Number,
            default: 2000
        },
        width: {
            // Component needs to be refactored to be more generic / Remember that we calculate tooltip position on this
            type: Number,
            default: 250
        },
        whitespace: {
            type: String,
            default: 'nowrap'
        },
        customLeftOffset: {
            type: Number,
            default: 0
        },
        customClass: {
            type: String,
            required: false,
            default: ''
        },
        staysOnHover: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isAvailable: false,
            isShow: false,
            localText: this.text,
            localTextColor: this.textColor,
            localBackgroundColor: this.backgroundColor,
            localTimeout: this.timeout,
            tooltipPosition: {
                left: '50%',
                transform: 'translateX(-50%)',
                top: '100%'
            },
            hoverTimeout: null // For hover handling
        }
    },
    computed: {
        tooltipStyle() {
            return {
                color: this.localTextColor,
                backgroundColor: this.localBackgroundColor,
                display: this.isShow ? 'block' : 'none',
                width: `${this.width}px`,
                'white-space': this.whitespace,
                ...this.tooltipPosition
            }
        }
    },
    mounted() {
        this.init(this.$parent.$options.inititator)
    },
    methods: {
        init(el) {
            if (!el) {
                return
            }
            this.initiator = el
            this.localText = el.dataset.tooltipText || this.text
            this.localTextColor = el.dataset.tooltipTextColor || this.textColor
            this.localBackgroundColor =
                el.dataset.tooltipBackgroundColor || this.backgroundColor
            this.localTimeout = parseInt(el.dataset.tooltipTimeout)
            this.isAvailable = true
        },
        calculateTooltipPosition(button) {
            const buttonRect = button.getBoundingClientRect()
            var left =
                buttonRect.left +
                buttonRect.width * 2 -
                this.width -
                this.customLeftOffset

            if (left + this.width > window.innerWidth) {
                left = window.innerWidth - this.width - 50
            }

            if (left < 10) {
                left = 10
            }

            this.tooltipPosition.left = `${left}px`
            this.tooltipPosition.top = `${buttonRect.bottom + window.scrollY}px`
            this.tooltipPosition.transform = ''
        },
        Open() {
            clearTimeout(this.hoverTimeout)
            this.isShow = true
            this.calculateTooltipPosition(this.initiator)
            if (this.timeout > 0) {
                this.hoverTimeout = setTimeout(() => {
                    this.hideTooltip()
                    this.initiator.blur()
                }, this.timeout)
            }
        },
        hideTooltip() {
            this.isShow = false
        },
        handleMouseEnter() {
            if (this.staysOnHover) {
                clearTimeout(this.hoverTimeout)
                this.isShow = true
            }
        },
        handleMouseLeave() {
            if (this.staysOnHover)
                this.hoverTimeout = setTimeout(() => {
                    this.isShow = false
                }, 300)
        }
    }
}
</script>

<style lang="scss" scoped>
.tooltip-vue {
    left: 50%;
    /* //style below is viewonly, We define width in: tooltipStyle() */
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    font-size: 14px;
    z-index: 999;
    position: absolute;
    padding: 16px 24px;
    border: 3px solid $sherpa-blue;
    text-align: center;
}

.arrow {
    position: absolute;
    background-color: $sherpa-blue;
    display: block;
    width: 4px;
    top: -4px;
    rotate: 45deg;
    height: 4px;
}

.arrow--top-right {
    right: 18px;
    transform: translateY(-50%);
}

.tooltip-vue.parallel-import {
    .arrow--top-right {
        right: 50%;
    }
}
</style>
